/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface WaitlistStudentRow
 */
export interface WaitlistStudentRow {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof WaitlistStudentRow
     */
    studentId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof WaitlistStudentRow
     */
    studentName: string;
}

/**
 * Check if a given object implements the WaitlistStudentRow interface.
 */
export function instanceOfWaitlistStudentRow(value: object): value is WaitlistStudentRow {
    if (!('studentId' in value) || value['studentId'] === undefined) return false;
    if (!('studentName' in value) || value['studentName'] === undefined) return false;
    return true;
}

export function WaitlistStudentRowFromJSON(json: any): WaitlistStudentRow {
    return WaitlistStudentRowFromJSONTyped(json, false);
}

export function WaitlistStudentRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): WaitlistStudentRow {
    if (json == null) {
        return json;
    }
    return {
        
        'studentId': ApiUserTasksGetPageParameterFromJSON(json['studentId']),
        'studentName': json['studentName'],
    };
}

export function WaitlistStudentRowToJSON(json: any): WaitlistStudentRow {
    return WaitlistStudentRowToJSONTyped(json, false);
}

export function WaitlistStudentRowToJSONTyped(value?: WaitlistStudentRow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'studentId': ApiUserTasksGetPageParameterToJSON(value['studentId']),
        'studentName': value['studentName'],
    };
}

